import { render, staticRenderFns } from "./BasePagen.vue?vue&type=template&id=330f0fa2&scoped=true&lang=pug&"
import script from "./BasePagen.vue?vue&type=script&lang=js&"
export * from "./BasePagen.vue?vue&type=script&lang=js&"
import style0 from "./BasePagen.vue?vue&type=style&index=0&id=330f0fa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330f0fa2",
  null
  
)

export default component.exports